export function debounce (func, delay) {
    let timeoutId;
    
    return (...args) => {
        clearTimeout(timeoutId);
        
        timeoutId = setTimeout(() => {
            func(...args);
        }, delay);
    };
};
